import { type CustomTooltipProps } from "ag-grid-react"
import React, { useEffect } from "react"
import { getTailwindValue } from "~/utils/tailwind"
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "../../Card"
import StaticBarChart from "../../graphs/StaticBarChart"
import { Button } from "../../Button"
import { trackEvent } from "../../../../hooks/useTrackingService"
import { formatName } from "~/utils/namingUtils"

export default function BarGraphTooltip(props: CustomTooltipProps) {
  const { estimatedSeasonalities, tooltipThresholds, openDialogFn } = props.value

  useEffect(() => {
    trackEvent("NPI Seasonality Profile Hovered")
  }, [])

  if (estimatedSeasonalities?.combinedSeasonality === undefined) {
    return null
  }

  return (
    <Card className="w-[400px]">
      <CardHeader className="items-center h-fit">
        <div className="flex flex-col">
          <CardTitle className="label-base text-left">Estimated Seasonality Profile</CardTitle>
          <CardTitle className="paragraph-base font-normal text-left">
            Based on {formatName("sale", true)} patterns for product category
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        <StaticBarChart
          data={estimatedSeasonalities.combinedSeasonality}
          color={getTailwindValue("--color-red-500")}
          thresholds={tooltipThresholds}
          height={94}
        />
      </CardContent>
      <CardFooter className="justify-start flex flex-row gap-3 w-full">
        <div className="flex flex-row items-center gap-1">
          <span className="bg-green-500 inline-block w-2 h-2 rounded-[999px]"></span>
          <div className="paragraph-sm font-normal">High {formatName("sale", true, true)}</div>
        </div>
        <div className="flex flex-row items-center gap-1">
          <span className="bg-orange-500 inline-block w-2 h-2 rounded-[999px]"></span>
          <div className="paragraph-sm font-normal">Medium {formatName("sale", true, true)}</div>
        </div>
        <div className="flex flex-row items-center gap-1">
          <span className="bg-red-500 inline-block w-2 h-2 rounded-[999px]"></span>
          <div className="paragraph-sm font-normal">Low {formatName("sale", true, true)}</div>
        </div>
      </CardFooter>
      <CardFooter className="w-full">
        <Button onClick={() => openDialogFn()} variant="neutral" className="w-full">
          How is this calculated?
        </Button>
      </CardFooter>
    </Card>
  )
}
